export type Feedback = {
  id: string;
  customer: string;
  initials: string;
  color: string;
  projectId: string;
  moveType: string;
  rating: number;
  title: string;
  body: string;
  date: string;
  source: "Email Survey" | "Google" | "Yelp" | "SMS Survey";
  status: "new" | "replied" | "flagged";
  crewMentioned: { name: string; initials: string; color: string }[];
  reply?: { body: string; author: string; date: string };
};

export const feedbackList: Feedback[] = [
  {
    id: "FB-1241",
    customer: "Joaquin Rivera",
    initials: "JR",
    color: "bg-emerald-500",
    projectId: "MV-2039",
    moveType: "Apartment — 2 BR",
    rating: 5,
    title: "Smoothest move I've ever had",
    body: "Marcus and the crew showed up exactly on time, wrapped everything in pads, and were incredibly respectful of the new place. They even reassembled the bed frame faster than we could find the screwdrivers. Will use Haulmark again without hesitation.",
    date: "2 hours ago",
    source: "Email Survey",
    status: "new",
    crewMentioned: [
      { name: "Marcus Reed", initials: "MR", color: "bg-brand-500" },
    ],
  },
  {
    id: "FB-1240",
    customer: "Anika Brennan",
    initials: "AB",
    color: "bg-violet-500",
    projectId: "MV-2038",
    moveType: "Residential — 3 BR House",
    rating: 5,
    title: "Worth every penny",
    body: "Samira ran the show like clockwork. The crew was respectful and fast — they had everything loaded by lunch and we were unpacking at the new house before 4pm. Pricing was exactly what was quoted. Highly recommend.",
    date: "Yesterday",
    source: "Google",
    status: "replied",
    crewMentioned: [
      { name: "Samira Khan", initials: "SK", color: "bg-indigo-500" },
    ],
    reply: {
      body: "Anika, thank you so much for the kind words! We'll make sure Samira and the crew see this. Welcome to the neighborhood!",
      author: "Elena Cordero · Operations Manager",
      date: "Yesterday",
    },
  },
  {
    id: "FB-1239",
    customer: "Devon & Lily Hartwell",
    initials: "DH",
    color: "bg-orange-600",
    projectId: "MV-2036",
    moveType: "Residential — 4 BR House",
    rating: 4,
    title: "Great crew, slight scheduling hiccup",
    body: "The crew themselves were excellent — friendly, careful with our things, and got the job done in great time. Only issue was the truck arrived about 45 minutes late and nobody called us to let us know. Otherwise five stars.",
    date: "2 days ago",
    source: "Email Survey",
    status: "new",
    crewMentioned: [
      { name: "Ronnie Vega", initials: "RV", color: "bg-brand-600" },
    ],
  },
  {
    id: "FB-1238",
    customer: "Rebecca Lin",
    initials: "RL",
    color: "bg-cyan-600",
    projectId: "MV-2034",
    moveType: "Apartment — Studio",
    rating: 2,
    title: "Disappointed with damage",
    body: "Two of my framed prints arrived with cracked glass and a corner of my dresser was scuffed pretty badly. The crew was nice but it felt rushed. Hoping the company will make this right.",
    date: "3 days ago",
    source: "Email Survey",
    status: "flagged",
    crewMentioned: [],
  },
  {
    id: "FB-1237",
    customer: "Carla Mendez",
    initials: "CM",
    color: "bg-amber-600",
    projectId: "MV-2033",
    moveType: "Apartment — 2 BR",
    rating: 5,
    title: "Couldn't have asked for better",
    body: "Diego and Tyler were fantastic. They showed up with a great attitude, treated my furniture like it was their own, and even helped reposition some boxes when I changed my mind about where they should go. Tipping well next time.",
    date: "4 days ago",
    source: "SMS Survey",
    status: "replied",
    crewMentioned: [
      { name: "Diego Alvarez", initials: "DA", color: "bg-emerald-500" },
      { name: "Tyler Brooks", initials: "TB", color: "bg-amber-500" },
    ],
    reply: {
      body: "Thank you Carla! Sharing this with Diego and Tyler right now.",
      author: "Elena Cordero · Operations Manager",
      date: "4 days ago",
    },
  },
  {
    id: "FB-1236",
    customer: "TerraTech Studios LLC",
    initials: "TS",
    color: "bg-orange-600",
    projectId: "MV-2032",
    moveType: "Office Relocation",
    rating: 5,
    title: "Best vendor we've used",
    body: "We've moved our office three times in the last five years and this was hands down the smoothest. Crew handled servers and ergonomic chairs with care. Will absolutely call Haulmark for our next expansion.",
    date: "5 days ago",
    source: "Google",
    status: "replied",
    crewMentioned: [
      { name: "Samira Khan", initials: "SK", color: "bg-indigo-500" },
      { name: "Jordan Pierce", initials: "JP", color: "bg-orange-500" },
    ],
    reply: {
      body: "Appreciate you, team TerraTech! Looking forward to the next one.",
      author: "Elena Cordero · Operations Manager",
      date: "5 days ago",
    },
  },
  {
    id: "FB-1235",
    customer: "Hiroshi Tanaka",
    initials: "HT",
    color: "bg-rose-500",
    projectId: "MV-2031",
    moveType: "Residential — 1 BR Condo",
    rating: 4,
    title: "Solid experience overall",
    body: "Crew was professional and the cost was reasonable. I felt like the inventory check at the end could've been more thorough — we found one missing box later (turns out it was already in storage). Otherwise a good experience.",
    date: "6 days ago",
    source: "Yelp",
    status: "new",
    crewMentioned: [],
  },
  {
    id: "FB-1234",
    customer: "Penelope Hart",
    initials: "PH",
    color: "bg-fuchsia-500",
    projectId: "MV-2030",
    moveType: "Senior Move — 2 BR Condo",
    rating: 5,
    title: "Patient and so kind with my mom",
    body: "Booked this move for my elderly mother and the crew was so patient and kind with her. They walked her through every step and double-checked which items were going to storage vs. her new apartment. Highly recommend for senior moves.",
    date: "1 week ago",
    source: "Google",
    status: "replied",
    crewMentioned: [
      { name: "Wes Holloway", initials: "WH", color: "bg-amber-600" },
    ],
    reply: {
      body: "Thank you Penelope! Wes will be thrilled to read this.",
      author: "Elena Cordero · Operations Manager",
      date: "1 week ago",
    },
  },
];

export const ratingBreakdown = [
  { stars: 5, count: 142, pct: 78 },
  { stars: 4, count: 24, pct: 13 },
  { stars: 3, count: 9, pct: 5 },
  { stars: 2, count: 5, pct: 3 },
  { stars: 1, count: 2, pct: 1 },
];

export const feedbackStats = [
  {
    label: "Avg Rating",
    value: "4.8",
    sub: "out of 5 stars",
    icon: "ri-star-fill",
    color: "text-amber-600 bg-amber-50",
  },
  {
    label: "Total Reviews",
    value: "182",
    sub: "last 90 days",
    icon: "ri-chat-quote-line",
    color: "text-indigo-600 bg-indigo-50",
  },
  {
    label: "Response Rate",
    value: "94%",
    sub: "within 24 hours",
    icon: "ri-reply-line",
    color: "text-emerald-600 bg-emerald-50",
  },
  {
    label: "Needs Attention",
    value: "3",
    sub: "flagged reviews",
    icon: "ri-error-warning-line",
    color: "text-rose-600 bg-rose-50",
  },
];